import types from './types';

const InitialState = {
    loaded: false,
    user: null,
    favorites: [],
    game: null,
    games_tab: 'inactive',
    bonus_state: null,
    bets_amount: 0,
    buttons: {
        game: false,
        changeAvatar: false,
        changePassword: false,
        favorite: false,
        take_bonus: false,
        spin: false
    }
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.bets:
            return {
                ...state,
                bets_amount: payload
            }
        case types.bonus_state:
            return {
                ...state,
                bonus_state: {
                    ...payload,
                    timestamp: Date.now()
                }
            }
        case types.online:
            return {
                ...state,
                online: payload,
                online_timestamp: Date.now()
            }
        case types.logout:
            return {
                ...InitialState,
                loaded: true
            }
        case types.favorites.add:
            return {
                ...state,
                favorites: [
                    payload,
                    ...state.favorites
                ]
            }
        case types.favorites.remove:
            return {
                ...state,
                favorites: state.favorites.filter(id => id !== payload)
            }
        case types.balance:
            return {
                ...state,
                user: {
                    ...state.user,
                    balance: payload
                }
            }
        case types.avatar:
            return {
                ...state,
                user: {
                    ...state.user,
                    avatar: payload
                }
            }
        case types.games_tab:
            return {
                ...state,
                games_tab: payload
            }
        case types.game:
            return {
                ...state,
                game: payload
            }
        case types.toggleButton:
            return {
                ...state,
                buttons: {
                    ...state.buttons,
                    [payload]: !state.buttons[payload]
                }
            }
        case types.loaded:
            return {
                ...state,
                loaded: true,
                user: payload.user,
                bets_amount: payload.bets,
                bonus_state: {
                    ...payload.bonus_state,
                    timestamp: Date.now()
                },
                favorites: payload.favorites
            }
        default:
            return state;
    } 
}